import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";
import {
  urlQueueSyncViewersCentersSecured,
  urlGetVisualMainQueueSecured,
} from "../../api/urls";

export const synchronizeData = createAction("SYNCHRONIZE_DATA", (obj) =>
  apiPost(urlQueueSyncViewersCentersSecured, obj, undefined, true)(),
);

export const getVisualMainQueue = createAction(
  "GET_VISUAL_MAIN_QUEUE",
  (filters) => apiGet(urlGetVisualMainQueueSecured, undefined, false)(),
);
